export default "__VITE_ASSET__iwW3aSO4__"